import { gate } from 'hub-http/gates';
export const PAYMENT_LINK_NEW_BADGE_PHASE_2 = 'Payments:NewBadgeSPLPhase2';
export const ASSOCIATION_CARD_REDESIGN = gate('CRM:Record:AssociationCardRedesign');
export const ASSOCIATION_CARD_NEW_API_LOAD_TEST = gate('CRM:Records:CardAssociatedObjectsView:FrontendCall');